export enum EContextMenuDisplayTypes {
	dropdown = 'dropdown',
	inline = 'inline',
}

export type TContextMenuDisplayTypes = keyof typeof EContextMenuDisplayTypes;
